<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : outStockBills.pkid > 0 ? '编辑' : '新建'"
      width="1200px"
      class="outStockBillsEdit"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="outStockBills"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col v-if="outStockBills.pkid > 0" :span="12">
          <el-form-item label="领料单号" prop="billNo">
            <el-input v-model="outStockBills.billNo" disabled/>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="领料仓" prop="locationName">
            <!--                   <span>-->
            <!--          {{outStockBills.warehouseName+' '+outStockBills.locationName}}-->
            <!--                       <el-button-->
            <!--                           slot="append"-->
            <!--                           icon="el-icon-search"-->
            <!--                           :disabled="outStockBills.pkid > 0"-->
            <!--                           @click="$refs.locationSelect.open()"/>-->
            <!--        </span>-->
            <el-input
                v-model="outStockBills.locationName"
                :disabled="outStockBills.pkid > 0"
                readonly
                placeholder="请选择仓位">
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  :disabled="outStockBills.pkid > 0"
                  @click="$refs.locationSelect.open()"/>
            </el-input>
            <warehouse-location-select ref="locationSelect" @select="locationSelect"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="要求日期" prop="requireDate">
            <el-date-picker
                v-model="outStockBills.requireDate"
                style="width: 100%"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"/>
          </el-form-item>
        </el-col>
        <el-col v-if="outStockBills.pkid > 0" :span="12">
          <el-form-item label="状态" prop="statusName">
            <el-input v-model="outStockBills.statusName" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="outStockBills.pkid > 0" :span="12">
          <el-form-item label="制单时间" prop="createTime">
            <el-input v-model="outStockBills.createTime" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="outStockBills.pkid > 0" :span="12">
          <el-form-item label="制单人" prop="creatorName">
            <el-input v-model="outStockBills.creatorName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="note">
            <el-input v-model="outStockBills.note" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle" style="margin-top: 10px">明细</div>
      <div style="text-align: right;">
        <el-button v-if="!disabled" type="primary" @click="$refs.BatchFLlocationSelect.open()">批量更新仓位</el-button>
        <el-button
            v-if="!disabled"
            type="primary"
            style="margin-bottom: 10px;margin-right: 10px;"
            @click="$refs.selectMaterial.open()">
          添加
        </el-button>
        <warehouse-location-select ref="BatchFLlocationSelect" @select="BatchFLlocationSelect"/>
      </div>
      <el-table
          class="tableBox"
          :data="outStockBillDetailVOS"
          border
          height="350"
          @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"/>
        <el-table-column prop="materialNo" align="left" label="物料编号" width="140"/>
        <el-table-column prop="specification" align="left" label="规格型号" width="220"/>
        <el-table-column prop="materialName" align="left" label="物料名称" min-width="150"/>
        <el-table-column prop="RefRowIndex" align="center" label="发料仓" width="220">
          <template slot-scope="scope">
            <el-input v-model="scope.row.locationName" readonly placeholder="请选择发料仓">
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="$refs.FLlocationSelect.open();setIndex(scope.$index)"/>
            </el-input>
            <warehouse-location-select ref="FLlocationSelect" @select="FLlocationSelect"/>
          </template>
        </el-table-column>
        <el-table-column prop="unitName" align="center" label="单位" width="60"/>
        <el-table-column prop="quantity" label="数量" width="100" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.quantity" class="inputCenter" placeholder="请输入出库数量"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="note"
            align="center"
            label="备注"
            width="120"
            show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input type="textarea" v-model="scope.row.note" placeholder="请输入"/>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <inventory-select ref="selectInventory" @select="selectInventory" @selectMore="selectMoreInventory"/>
    <material-select ref="selectMaterial" @select="selectMoreMaterial" @selectMore="selectMoreMaterial"/>
  </el-dialog>
</template>

<script>
  import MaterialSelect from "@/views/information/Material/MaterialMoreSelect";
  import InventorySelect from "../Inventory/InventorySelect";
  import WarehouseLocationSelect from "@/views/information/WarehouseLocation/WarehouseLocationSelect";
  import moment from "moment";

  export default {
    name: "OutStockOrderEdit",
    components: {MaterialSelect, InventorySelect, WarehouseLocationSelect},
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        index: 0,
        outStockBills: {
          outStockType: 12,
          pkid: 0,
          billNo: "",
          relBillNo: "",
          relBillId: "",
          requireDate: "",
          status: "",
          statusName: "",
          creatorName: "",
          createTime: "",
          note: "",
          locationName: "",
          locationNo: "",
          locationId: "",
          warehouseNo: "",
          warehouseName: "",
          outStockBillDetailVOS: [],
        },
        outStockBillDetailVOS: [],
        multipleSelection: [],
        ruleValidate: {
          locationName: {required: true, message: "请选择领料仓位", trigger: "change"},
          FLlocationName: {required: true, message: "请选择发料仓位", trigger: "change"},
          requireDate: {required: true, message: "请选择要求日期", trigger: "change"},
          quantity: {required: true, trigger: "blur"},
        },
      };
    },
    methods: {
      open(row, disabled) {
        this.dialogVisible = true;
        this.outStockBills.requireDate = moment(new Date()).format("YYYY-MM-DD");
        if (row) {
          this.outStockBills.pkid = row.pkid;
          this.getData();
        }
        if (disabled) {
          this.disabled = true;
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        // this.outStockBills.outStockBillDetailVOS = val;
      },

      // 根据出货订单id查询详细信息
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `outStockTransfers/${this.outStockBills.pkid}`)
          .then((resp) => {
            if (resp.success) {
              this.outStockBills = Object.assign(this.outStockBills, resp.data);
              // this.outStockBills.locationName = this.outStockBills.warehouseName + "-" + this.outStockBills.locationName;
              this.outStockBills.locationName = this.outStockBills.locationName + "(" + this.outStockBills.warehouseName + ")";
              this.outStockBills.outStockBillDetailVOS.forEach(item => {
                // item.locationName = item.warehouseAreaName + "-" + item.locationName;
                item.locationName = item.locationName + "(" + item.warehouseAreaName + ")";
              });
              this.outStockBillDetailVOS = this.outStockBills.outStockBillDetailVOS;
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      selectInventory(row) {
        const arr = this.outStockBills.outStockBillDetailVOS.filter(
          (item) => item.materialNo === row.materialNo && item.locationId === row.locationId,
        );
        if (arr.length) {
          this.$confirm("物料已存在，请勿重复添加", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }

        const materialItem = {
          materialSn: row.materialSn,
          unitId: row.unitId,
          unitNo: row.unitNo,
          unitName: row.unitName,
          materialId: row.materialId,
          materialNo: row.materialNo,
          materialName: row.materialName,
          quantity: row.quantity,
          price: row.price,
          locationId: row.locationId,
          locationName: row.locationName,
          note: "",
          originQuantity: row.quantity,
        };
        this.outStockBills.outStockBillDetailVOS.push(materialItem);
        this.outStockBillDetailVOS.push(materialItem);
        this.multipleSelection.push(materialItem);
      },

      selectMoreInventory(row) {
        row.forEach(item => {
          this.selectInventory(item);
        });
      },


      selectMaterial(row) {
        const arr = this.outStockBills.outStockBillDetailVOS.filter(
          (item) => item.materialNo === row.materialNO,
        );
        if (arr.length) {
          this.$confirm("物料已存在，请勿重复添加", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }

        const materialItem = {
          materialSn: "",
          unitId: row.measuringUnitID,
          unitNo: row.unitNO,
          unitName: row.unitName,
          materialId: row.materialID,
          materialNo: row.materialNO,
          materialName: row.materialName,
          specification: row.specification,
          quantity: 1,
          price: 0,
          locationId: row.locationId,
          locationName: row.warehouseLocationName == null ? "" : row.warehouseLocationName + "(" + row.warehouseAreaName + ")",
          note: "",
          originQuantity: 1,
        };
        // this.outStockBills.outStockBillDetailVOS.push(materialItem);
        this.outStockBillDetailVOS.push(materialItem);
      },

      selectMoreMaterial(row) {
        row.forEach(item => {
          this.selectMaterial(item);
        });
      },

      setIndex(index) {
        this.index = index;
      },

      //仓位选择
      locationSelect(row) {
        this.outStockBills.locationName = row.warehouseLocationName + "(" + row.warehouseAreaName + ")";
        this.outStockBills.locationNo = row.warehouseLocationNo;
        this.outStockBills.locationId = row.pkId;
      },
      BatchFLlocationSelect(row) {
        this.outStockBillDetailVOS.forEach(item => {
          item.locationName = row.warehouseLocationName + "(" + row.warehouseAreaName + ")";
          item.locationId=row.pkId;
        });
      },

      FLlocationSelect(row) {
        this.outStockBillDetailVOS[this.index].locationName =  row.warehouseLocationName+ "(" + row.warehouseAreaName + ")";
        this.outStockBillDetailVOS[this.index].locationId = row.pkId;
      },


      // 编辑、新建
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.multipleSelection.length) {
              this.$confirm("请勾选库存明细", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            let flag = false;
            this.multipleSelection.forEach(item => {
              if (!item.locationName) {
                flag = true;
              }
            });
            if (flag) {
              this.$confirm("请选择发料仓", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            this.outStockBills.outStockBillDetailVOS = this.multipleSelection;
            this.outStockBills.outStockBillDetailVOS.forEach(s => {
              s.actualQuantity = s.quantity;
            });
            this.submitLoading = true;
            this.$http
              .save("basic", "outStockTransfers", this.outStockBills)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.outStockBills.pkid > 0) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.outStockBillsEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.outStockBillsEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.outStockBillsEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 10px;
  padding-bottom: 69px;
  height: 90%;
}

.outStockBillsEdit .el-divider--horizontal {
  margin: 10px 0;
}

.outStockBillsEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;
}

.tableBox .el-form-item__content {
  margin-left: 0 !important;
}

.tableBox .el-form-item {
  margin-bottom: 0;
}

.tableBox .el-input--mini .el-input__inner {
  text-align: center;
}
</style>
